let scriptLoaded = false;

export function loadRazorpayScript() {
  if (scriptLoaded || window.Razorpay) {
    scriptLoaded = true;
    return Promise.resolve(true);
  }
  return new Promise((resolve) => {
    const s    = document.createElement('script');
    s.src      = 'https://checkout.razorpay.com/v1/checkout.js';
    s.async    = true;
    s.onload   = () => { scriptLoaded = true; resolve(true); };
    s.onerror  = () => resolve(false);
    document.body.appendChild(s);
  });
}
